<template>
  <SfButtonDs
    v-show="!store.isOpen"
    icon-only
    icon-before="table-columns"
    variant="secondary"
    data-testid="left-drawer-report-graphs-toggle"
    :aria-label="I18n.t('report.drawer.expand')"
    @click="store.openDrawer"
  />
</template>

<script setup lang="ts">
import { useReportGraphsDrawer } from '@app/application/report/store/use-report-graphs-drawer'
import SfButtonDs from '@app/shared/vue/components/sf-button/sf-button-ds.vue'
import useI18n from '@app/shared/vue/composables/use-I18n'

const I18n = useI18n()
const store = useReportGraphsDrawer()
</script>
